"use client";

import { cn } from "@/lib/utils";

import { useCookieConsent } from "./cookie-consent-context";

/**
 * Footer entry point to the consent manager. Shown only to in-region visitors
 * (who saw the banner and need a way to withdraw/change consent). It is a
 * button, not a link, because it opens a dialog rather than navigating.
 */
export function CookiePreferencesLink({ className }: { className?: string }) {
  const { mounted, region, openPreferences } = useCookieConsent();

  if (!mounted || region !== "required") {
    return null;
  }

  return (
    <button
      type="button"
      onClick={openPreferences}
      className={cn("cursor-pointer transition-colors", className)}
    >
      Cookie Preferences
    </button>
  );
}
